import React from "react";

import amazonLogo from "@assets/amazon-logo.svg";
import { LearnMoreTooltip } from "@features/sales-v3/top-level-filters/components/learn-more-tooltip";
import { ConnectionType } from "@north-beam/nb-client-side";
import {
  ConnectionCard,
  KnowledgeBaseLearnMoreLink,
} from "@pages/settings/connection-card";
import { type LoginComponentChildrenProps } from "@pages/settings/connection-status-manager";
import { type CardProps2 } from "@pages/settings/core";

import { AmazonSellerLoginRegionalComponent } from "./seller-regional-login";

const CONNECTION_TYPE_NAME = "Amazon Seller";
export function AmazonSellerConnectionCard(props: CardProps2) {
  return (
    <ConnectionCard
      type={type}
      supportMultipleAccounts="primaryAccounts"
      connectionTypeName={CONNECTION_TYPE_NAME}
      connectionCallToAction={`
        Integrate your Amazon Seller data here.
      `}
      logoUrl={amazonLogo}
      logoAltText="Amazon Seller Logo"
      precontent={
        <div className="mb-4 italic">
          <LearnMoreTooltip
            overlayClassName="max-w-[80%]"
            contentClassName="w-fit"
            title={`${CONNECTION_TYPE_NAME} Integration Limitations`}
            content={
              <>
                <li>
                  This connection populates <b>Revenue</b> from Amazon Seller
                  Central.
                </li>
                <li>
                  Revenue data takes up to <b>8–10 weeks</b> to fully populate,
                  including historical data from <b>January 1, 2000, onward</b>.
                  The timeline highly depends on your order volume.
                </li>
                <li>Amazon Vendor Central or DSP are currently unsupported</li>
                <KnowledgeBaseLearnMoreLink
                  className="mt-4"
                  connectionTypeName={CONNECTION_TYPE_NAME}
                  knowledgeBaseLink="https://docs.northbeam.io/docs/tracking-for-amazon"
                />
              </>
            }
          >
            Learn about our {CONNECTION_TYPE_NAME}{" "}
            <span className="underline text-danger">
              details and limitations
            </span>
          </LearnMoreTooltip>
        </div>
      }
    >
      {({ setStatus, accounts }: LoginComponentChildrenProps) => (
        <AmazonSellerLoginRegionalComponent
          setStatus={setStatus}
          accounts={accounts}
          integrationDetails={props.integrationDetails}
        />
      )}
    </ConnectionCard>
  );
}

const type = ConnectionType.integration_amazon_seller;
